import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TabsRow, TabItem, TabLabelRow, TabValueRow, TabValue, TabStatusText } from './style'
import AlertIcon from '@/assets/icons/alert-icon'
import SuccessIcon from '@/assets/icons/success-icon'
import { PROGRESS_TABS, TABS } from '../../constants'

const Tabbar = ({ isDraft, activeTab, onChangeTab, tabSummary, monitoring }) => {
  const visibleProgressTabs = PROGRESS_TABS.filter(({ key }) => {
    if (key === TABS.STATE) return monitoring?.state_evaluation === true
    if (key === TABS.PRESSURE) return monitoring?.pressure_evaluation === true
    if (key === TABS.RESPONSE) return monitoring?.response_evaluation === true
    return true
  })

  return (
    <TabsRow>
      {visibleProgressTabs.map(({ key, labelId, defaultMessage }) => {
        const summary = tabSummary[key]
        const tone = summary?.status ? 'success' : 'warning'

        return (
          <TabItem
            key={key}
            type="button"
            $active={activeTab === key}
            onClick={() => onChangeTab(key)}
            data-test={`monitoring-tab-${key}`}
          >
            <TabLabelRow>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
              {tone === 'warning' ? <AlertIcon /> : <SuccessIcon />}
            </TabLabelRow>
            <TabValueRow>
              <TabValue>{summary.progress}%</TabValue>
              {isDraft && <TabStatusText tone={tone}>
                {tone === 'success' ? (
                  <FormattedMessage id="monitoringStatusReady" defaultMessage="Ready to submit" />
                ) : (
                  <FormattedMessage id="monitoringStatusIncomplete" defaultMessage="Incomplete" />
                )}
              </TabStatusText>}
            </TabValueRow>
          </TabItem>
        )
      })}

      <TabItem
        type="button"
        $active={activeTab === TABS.EVALUATION}
        onClick={() => onChangeTab(TABS.EVALUATION)}
        data-test="monitoring-tab-evaluation"
      >
        <TabLabelRow>
          <FormattedMessage id="monitoringTabEvaluationData" defaultMessage="Evaluation data" />
        </TabLabelRow>
        <TabValueRow>
          <TabValue>
            <FormattedMessage id="monitoringTabResults" defaultMessage="Results" />
          </TabValue>
        </TabValueRow>
      </TabItem>
    </TabsRow>
  )
}

export default Tabbar
